let classes;

function filterItems(form) {
    const checkedFilters = Array.from(
        form.querySelectorAll('input[type="checkbox"]:checked')
    ).map(cb => cb.value);


    classes.forEach(item => {
        const itemAges = (item.dataset.calendarAge || '').split(/\s+/);

        const isVisible = itemAges.some(age => checkedFilters.includes(age));

        item.dataset.calendarVisible = isVisible ? 'true' : 'false';
    });
}


export default function FiltersHandler() {
    const filterToggle = document.querySelector('[data-filters-toggle]');

    if (filterToggle) {
        classes = document.querySelectorAll('[data-calendar-slot]');

        if (classes.length <= 0) filterToggle.classList.add('hidden');

        filterToggle.addEventListener('click', () => {
            filterToggle.parentNode.classList.toggle('open');
        });

        if (classes) {
            const filterForm = filterToggle.parentNode.querySelector('form');

            if (filterForm) {
                filterForm.addEventListener('change', () => {
                    filterItems(filterForm);
                });
            }
        }
    }
}
  